<template>
  <ckeditor :editor="editor" v-model="value" :config="editorConfig" @ready="onReady" @input="onInput" />
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";

// Builds : @doc
// https://ckeditor.com/docs/ckeditor5/latest/getting-started/legacy/installation-methods/predefined-builds.html
// Builder : https://ckeditor.com/ckeditor-5/builder/
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// // Pas de menu - édition inline avec menu au survol et blocs
//import BalloonBlockEditor from "@ckeditor/ckeditor5-build-balloon-block";
// // Requiert CKEditor >= 34
//import DocumentEditor from "@ckeditor/ckeditor5-build-decoupled-document";
// Superbuild
//https://ckeditor.com/docs/ckeditor5/latest/getting-started/legacy/installation-methods/quick-start.html

// Plugins
//import CodeBlock from "@ckeditor/ckeditor5-code-block";
//import { Image, ImageUpload } from "@ckeditor/ckeditor5-image";
//import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";
//import { Mention } from "@ckeditor/ckeditor5-mention";

//import Mention from "@ckeditor/ckeditor5-mention/src/mention";   // erreur duplicated module si actif
//import Base64UploadAdapter from "@ckeditor/ckeditor5-upload";
//import { UploadAdapter } from "@ckeditor/ckeditor5-upload";

//ClassicEditor.builtinPlugins = [...ClassicEditor.builtinPlugins];
//import ToolbarLineBreak from "@ckeditor/ckeditor5-ui/src/toolbar/linebreak";

//import "@ckeditor/ckeditor5-build-classic/build/ckeditor.css";
//import "@ckeditor/ckeditor5-mention/theme/mention.css";
//import "@ckeditor/ckeditor5-code-block/theme/codeblock.css";

export default {
  name: "CKEditor",
  components: {
    ckeditor: CKEditor.component
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      //editor: BalloonBlockEditor,
      //editor: DocumentEditor,

      editorConfig: {
        //licenseKey: "GPL", // required starting v44.0.0
        plugins: [...ClassicEditor.builtinPlugins],
        //plugins: [...BalloonBlockEditor.builtinPlugins],
        //plugins: [...DocumentEditor.builtinPlugins],
        // Language setting
        language: "fr",
        // Allow multiline (false adds 3-dots sub-menu)
        shouldNotGroupWhenFull: true,
        // Toolbar items
        toolbar: [
          "SelectAll", // ok
          "|",
          "Heading", // ok
          "Bold", // ok
          "Italic", // ok
          "BlockQuote", // ok
          "Link", // ok
          "|",
          "BulletedList", // ok
          "NumberedList", // ok
          "Outdent", // ok
          "Indent", // ok
          "|",
          "ImageUpload", // ok
          "ImageTextAlternative", // ok
          //"CKFinder", // ok but requires plugin or custom method
          "MediaEmbed", // ok
          // Multiline toolbar: starting from CKEditor 24
          //  https://ckeditor.com/blog/CKEditor-5-v24.0.0-with-multiline-toolbar-and-accessible-input-labels/
          // "-", // Use this to break into a new line // KO
          // "|", // Use this to group tools into blocks
          /* Toolbar features that are KO (plugin should be loaded, or method/conf added to make it work) : 
            "Autoformat", "AutoLink", "AutoMediaEmbed", "BlockQuoteEditing", "BoldEditing", "CKFinderEditing", 
            "CKFinderUI", "CKFinderUploadAdapter", "Clipboard", "CloudServices", "ContextualBalloon", "Delete", 
            "EasyImage", "Enter", "Essentials", "FileRepository", "HeadingEditing", "Image", "ImageCaption", 
            "ImageCaptionEditing", "ImageEditing", "ImageStyle", "ImageStyleEditing", "ImageStyleUI", 
            "ImageTextAlternativeEditing", "ImageTextAlternativeUI", "ImageToolbar", "ImageUploadEditing", 
            "ImageUploadUI", "IndentEditing", "IndentUI", "Input", "ItalicEditing", "LinkEditing", "LinkUI", 
            "List", "ListEditing", "MediaEmbedEditing", "MediaEmbedUI", "Notification", "Paragraph", "PasteFromOffice", 
            "PastePlainText", "PendingActions", "SelectAllEditing", "SelectAllUI", "ShiftEnter", "Table", 
            "TableClipboard", "TableEditing", "TableKeyboard", "TableMouse", "TableSelection", "TableToolbar", 
            "TableUtils", "TextTransformation", "TwoStepCaretMovement", "Typing", "UndoEditing", "Widget", 
            "WidgetToolbarRepository", "WidgetTypeAround",
            // And also these toolbar elements:
            "fontfamily",
            "fontsize",
            "fontColor",
            "fontBackgroundColor",
            "underline",
            "strikethrough",
            "subscript",
            "superscript",
            "alignment",
            "code",
            "codeBlock",
            "sourceEditing",
          */
          "|",
          "Undo", // ok
          "Redo" // ok
        ],
        mention: {
          feeds: [
            {
              marker: "@",
              feed: ["@John", "@Jane", "@Jake", "@Jill", "@Joe"],
              minimumCharacters: 1
            },
            {
              marker: "#",
              feed: ["#topic1", "#topic2", "#topic3"],
              minimumCharacters: 1
            }
          ]
        },
        // Custom heading styles
        heading: {
          options: [
            { model: "paragraph", title: this.$i18n.t("Paragraph"), class: "ck-heading_paragraph" },
            { model: "heading1", view: "h1", title: this.$i18n.t("Heading 1"), class: "ck-heading_heading1" },
            { model: "heading2", view: "h2", title: this.$i18n.t("Titre 2"), class: "ck-heading_heading2" },
            { model: "heading3", view: "h2", title: this.$i18n.t("Titre 3"), class: "ck-heading_heading3" },
            { model: "heading4", view: "h2", title: this.$i18n.t("Heading 4"), class: "ck-heading_heading4" },
            { model: "heading5", view: "h2", title: this.$i18n.t("Heading 5"), class: "ck-heading_heading5" },
            { model: "heading6", view: "h2", title: this.$i18n.t("Heading 6"), class: "ck-heading_heading6" },
            { model: "pre", view: "pre", title: this.$i18n.t("Code (pre - for code block)"), class: "ck-code-pre" },
            {
              model: "code",
              view: "code",
              title: this.$i18n.t("Code (code - for inline code)"),
              class: "ck-code-code"
            },
            { model: "kbd", view: "kbd", title: this.$i18n.t("Code (kbd - for keyboard input)"), class: "ck-code-kbd" },
            {
              model: "var",
              view: "var",
              title: this.$i18n.t("Code (var - for a variable of math expression)"),
              class: "ck-code-var"
            },
            {
              model: "samp",
              view: "samp",
              title: this.$i18n.t("Code (samp - for program output)"),
              class: "ck-code-samp"
            }
          ]
        },
        // Custom fonts
        fontFamily: {
          options: [
            "default",
            "Courier New, Courier, monospace",
            "Georgia, serif",
            "Tahoma, Geneva, sans-serif",
            "Times New Roman, Times, serif",
            "Verdana, Geneva, sans-serif",
            "Ubuntu, Arial, sans-serif",
            "Ubuntu Mono, Courier New, Courier, monospace"
          ]
        },
        fontColor: {
          colorPicker: {
            // Use 'hex' format for output instead of 'hsl'.
            format: "hex"
          }
        },
        // Available font sizes
        fontSize: {
          options: ["tiny", "small", "default", "big", "huge"]
        },
        // Custom code languages
        codeBlock: {
          languages: [
            { language: "plaintext", label: this.$i18n.t("Plain text") }, // Default
            { language: "javascript", label: this.$i18n.t("JavaScript") },
            { language: "html", label: this.$i18n.t("HTML") },
            { language: "css", label: this.$i18n.t("CSS") }
          ]
        }
      }
    };
  },
  methods: {
    onReady(editorInstance) {
      /*
      console.log("CKEditor is ready!", editorInstance);
      console.log(editorInstance.plugins._availablePlugins);
      console.log(editorInstance.plugins._plugins);
      */
      this.$emit("ready", editorInstance);
    },
    onInput(data) {
      this.$emit("input", data);
    }
  }
};
</script>

<style>
.ck.ck-powered-by {
  display: none !important;
}
.ck.ck-editor {
  width: 100%;
}
.ck-toolbar {
  width: 100%;
}
.ck-editor__editable {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.ck.ck-editor__editable_inline {
  width: 100%;
  height: auto;
  min-height: 8rem;
}
.ck.ck-content {
  min-height: 8rem;
  padding-bottom: 0.5rem;
}
.v-card.v-sheet .ck.ck-content p,
.v-card.v-sheet.theme--light .ck.ck-content p {
  margin: 0.25rem 0 0.5rem 0;
}
.ck-toolbar {
  flex-wrap: wrap;
}
</style>
